import { ROUTE_PATHS } from 'core/constants/routePath'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'

export const DebugLayout = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const requetesActive =
    pathname === ROUTE_PATHS.IADOCS_DEBUG ||
    pathname.startsWith(`${ROUTE_PATHS.IADOCS_DEBUG}/requetes`)

  return (
    <div className="iadocs-debug-shell">
      <header className="debug-topbar">
        <button
          type="button"
          className="debug-topbar-brand"
          onClick={() => navigate('/')}
        >
          Lauria
        </button>
        <div className="debug-topbar-title">
          <div className="debug-topbar-kicker">IADocs / Debug</div>
          <div className="debug-topbar-meta">{t('iadocs.debug.accroche')}</div>
        </div>
        <div className="debug-topbar-status">Console</div>
      </header>
      <div className="iadocs-debug-frame">
        <aside className="iadocs-debug-sidebar">
          <p className="debug-side-kicker">DEBUG</p>
          <nav aria-label="">
            <NavLink
              to={ROUTE_PATHS.IADOCS_DEBUG}
              className={() =>
                `debug-side-link${requetesActive ? ' is-active' : ''}`
              }
            >
              <span className="debug-side-index">01</span>
              Requêtes
            </NavLink>
            <NavLink
              to={`${ROUTE_PATHS.IADOCS_DEBUG}/documents`}
              className={({ isActive }) =>
                `debug-side-link${isActive ? ' is-active' : ''}`
              }
            >
              <span className="debug-side-index">02</span>
              Documents S3
            </NavLink>
            <NavLink
              to={`${ROUTE_PATHS.IADOCS_DEBUG}/statistiques`}
              className={({ isActive }) =>
                `debug-side-link${isActive ? ' is-active' : ''}`
              }
            >
              <span className="debug-side-index">03</span>
              Statistiques
            </NavLink>
          </nav>
        </aside>
        <div className="iadocs-debug-main">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
